import * as React from "react";
import { Button, Space } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { CardContent } from "../../../components/antd/card/CardContent";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";

interface Props {}
export const SecretDataAWS: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const isPasswordVisible = useCpFormValue(`aws.secretKey.isVisible`);

  return (
    <>
      <CardContent>
        <div style={{ width: 600 }}>
          <CpFormItem>
            <CpLabel name={`aws.accessKey`}>Access Key</CpLabel>
            <CpInput name={`aws.accessKey`} />
            <CpErrorWarning name={`aws.accessKey`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`aws.secretKey.value`}>Secret Key</CpLabel>
            <Space.Compact>
              <CpInput name={`aws.secretKey.value`} type={isPasswordVisible ? "text" : `password`} />
              <Button
                onClick={() => formSetValue(id, `aws.secretKey.isVisible`, !isPasswordVisible)}
                icon={isPasswordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              />
            </Space.Compact>
            <CpErrorWarning name={`aws.secretKey.value`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`aws.roleArn`}>Role ARN</CpLabel>
            <CpInput name={`aws.roleArn`} />
            <CpErrorWarning name={`aws.roleArn`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabel name={`aws.externalId`}>External ID</CpLabel>
            <CpInput name={`aws.externalId`} />
            <CpErrorWarning name={`aws.externalId`} />
          </CpFormItem>
        </div>
      </CardContent>
    </>
  );
};
